/* Inner Compass — Cookiebeleid.
 * Dutch authoritative; English faithful translation.
 * Section 7 reflects the actual current implementation of innercompass.tech
 * (no cookies, no analytics/tracking SDKs — only strictly-necessary localStorage). */

export const cookiesContent = {
  nl: [
    {
      heading: "1. Over dit cookiebeleid",
      body:
        "Dit beleid legt uit hoe de website en webapplicatie van Inner Compass cookies en vergelijkbare technologieën gebruiken.",
    },
    {
      heading: "2. Wat zijn cookies?",
      body: [
        "Cookies zijn kleine gegevensbestanden die door een website op je apparaat kunnen worden opgeslagen.",
        "Daarnaast bestaan vergelijkbare technologieën, zoals local storage en session storage.",
      ],
    },
    {
      heading: "3. Noodzakelijke technologieën",
      body: "Inner Compass kan strikt noodzakelijke cookies of lokale opslag gebruiken voor functies zoals:",
      list: [
        "beveiliging;",
        "sessiebeheer;",
        "authenticatie;",
        "taalvoorkeuren;",
        "essentiële websitefunctionaliteit.",
      ],
      note: "Voor strikt noodzakelijke technologieën is niet altijd toestemming vereist.",
    },
    {
      heading: "4. Analytics",
      body: [
        "Als Inner Compass analytische technologie gebruikt waarvoor toestemming vereist is, mag deze pas worden geactiveerd nadat de bezoeker daarvoor toestemming heeft gegeven.",
        "Waar mogelijk gebruiken we privacyvriendelijke of geaggregeerde metingen.",
      ],
    },
    {
      heading: "5. Marketing en advertenties",
      body:
        "Inner Compass gebruikt geen advertentie- of marketingcookies tenzij dit uitdrukkelijk op deze pagina wordt vermeld en, waar wettelijk vereist, vooraf toestemming is verkregen.",
    },
    {
      heading: "6. Cookievoorkeuren",
      body: [
        "Wanneer niet-noodzakelijke cookies worden gebruikt, moet de website een manier bieden om toestemming te geven, te weigeren en later weer in te trekken.",
        "Het weigeren van niet-noodzakelijke cookies mag de essentiële werking van de website niet blokkeren.",
      ],
    },
    {
      heading: "7. Actuele technische implementatie",
      body: "Op dit moment plaatst innercompass.tech:",
      list: [
        "geen cookies;",
        "geen analytics- of trackingtechnologie van derden;",
        "geen marketing- of advertentietechnologie.",
      ],
    },
    {
      subheading: "Strikt noodzakelijke lokale opslag",
      body: "De webapplicatie gebruikt lokale opslag in je browser (localStorage en sessionStorage) uitsluitend voor noodzakelijke functies:",
      list: [
        "een beveiligd sessietoken, zodat je ingelogd blijft;",
        "je gekozen taal (Nederlands of Engels);",
        "weergave-voorkeuren van de app (bijvoorbeeld modus);",
        "een korte veiligheidsteller bij accountverwijdering, om misbruik te beperken.",
      ],
      note: "Deze gegevens blijven in je eigen browser. Je kunt ze altijd zelf verwijderen via de instellingen van je browser of door uit te loggen.",
    },
    {
      subheading: "Lettertypen van derden",
      body:
        "De website laadt lettertypen via Google Fonts (fonts.googleapis.com en fonts.gstatic.com). Daarbij ontvangt Google het IP-adres van je apparaat om het lettertype te kunnen aanleveren. Er worden hiervoor geen cookies geplaatst.",
    },
    {
      subheading: "Geen toestemmingsbanner",
      body:
        "Omdat er geen niet-noodzakelijke cookies of trackers actief zijn, toont innercompass.tech geen cookiebanner. Als in de toekomst niet-noodzakelijke technologie wordt toegevoegd, wordt deze pagina bijgewerkt en wordt waar wettelijk vereist vooraf toestemming gevraagd.",
    },
    {
      heading: "8. Contact",
      body: "Vragen over privacy of cookies:",
      list: ["privacy@innercompass.tech"],
    },
  ],
  en: [
    {
      heading: "1. About this cookie policy",
      body:
        "This policy explains how the Inner Compass website and web application use cookies and similar technologies.",
    },
    {
      heading: "2. What are cookies?",
      body: [
        "Cookies are small data files that a website can store on your device.",
        "Similar technologies also exist, such as local storage and session storage.",
      ],
    },
    {
      heading: "3. Necessary technologies",
      body: "Inner Compass may use strictly necessary cookies or local storage for functions such as:",
      list: ["security;", "session management;", "authentication;", "language preferences;", "essential website functionality."],
      note: "Consent is not always required for strictly necessary technologies.",
    },
    {
      heading: "4. Analytics",
      body: [
        "If Inner Compass uses analytics technology for which consent is required, it may only be activated after the visitor has given consent.",
        "Where possible we use privacy-friendly or aggregated measurement.",
      ],
    },
    {
      heading: "5. Marketing and advertising",
      body:
        "Inner Compass does not use advertising or marketing cookies unless this is explicitly stated on this page and, where legally required, consent has been obtained in advance.",
    },
    {
      heading: "6. Cookie preferences",
      body: [
        "Where non-essential cookies are used, the website must offer a way to give, refuse and subsequently withdraw consent.",
        "Refusing non-essential cookies must not block the essential functioning of the website.",
      ],
    },
    {
      heading: "7. Current technical implementation",
      body: "Currently innercompass.tech sets:",
      list: [
        "no cookies;",
        "no third-party analytics or tracking technology;",
        "no marketing or advertising technology.",
      ],
    },
    {
      subheading: "Strictly necessary local storage",
      body: "The web application uses local storage in your browser (localStorage and sessionStorage) only for necessary features:",
      list: [
        "a secure session token so that you stay signed in;",
        "your chosen language (Dutch or English);",
        "display preferences for the app (for example, mode);",
        "a short safety counter on account deletion, to limit abuse.",
      ],
      note: "This data stays in your own browser. You can delete it yourself at any time via your browser settings or by signing out.",
    },
    {
      subheading: "Third-party fonts",
      body:
        "The website loads fonts via Google Fonts (fonts.googleapis.com and fonts.gstatic.com). In doing so, Google receives your device's IP address so that the font can be delivered. No cookies are placed for this.",
    },
    {
      subheading: "No consent banner",
      body:
        "Because no non-essential cookies or trackers are active, innercompass.tech does not show a cookie banner. If non-essential technology is added in the future, this page will be updated and, where legally required, consent will be requested in advance.",
    },
    {
      heading: "8. Contact",
      body: "Questions about privacy or cookies:",
      list: ["privacy@innercompass.tech"],
    },
  ],
};
